<template>
  <div
    class="grid lg:bg-white [border-radius:calc(25px-2vh)] lg:shadow-lg relative h-fit p-2 w-fit lg:w-[calc(100%-2vw)] align-middle my-[2vh] mx-auto"
  >
    <div
      class="lg:grid grid-cols-1 grid-rows-3 lg:grid-cols-2 lg:grid-rows-1 justify-between items-center h-full w-full relative"
    >
      <div
        class="flex justify-center lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2"
      >
        <router-link
          to="/"
          class="grid w-fit justify-center bg-white [border-radius:calc(25px-2vh)] shadow-lg"
        >
          <img
            :src="logoSrc"
            alt="CCO Logo"
            class="lg:h-[12vh] h-[9vh] w-auto"
          />
        </router-link>
      </div>

      <nav
        class="items-center flex justify-center lg:justify-start my-4 lg:my-0"
      >
        <router-link
          to="/"
          class="text-gray-700 font-medium mr-6 p-2 bg-[#152d40] text-white [border-radius:calc(25px-2vh)] hover:bg-blue-500"
          >Anasayfa</router-link
        >
        <router-link
          to="/services"
          class="text-gray-700 font-medium lg:mr-6 bg-[#152d40] text-white [border-radius:calc(25px-2vh)] p-2 lg:text-black lg:bg-white/0"
          >Hizmetlerimiz</router-link
        >
      </nav>

      <nav class="items-center flex justify-center lg:justify-end">
        <router-link
          to="/contacts"
          class="text-gray-700 font-medium p-2 lg:bg-[#152d40] lg:text-white text-[#152d40] bg-white rounded-md lg:hover:bg-blue-500 align-right"
          >Bizimle İletişim Kurun</router-link
        >
      </nav>
    </div>
  </div>
</template>

<script>
import logoImage from '@/assets/logo.png' // Logoyu import edin

export default {
  name: 'NavBar',
  data() {
    return {
      logoSrc: logoImage, // Resmi template'de kullanmak için data'ya atayın
    }
  },
}
</script>

<style scoped></style>
